



































import * as vr from '@/helpers/validation';
import type { PropType } from 'vue';
import type { AccountItem } from '@/api/schema';

export default {
  name: 'BrandNameEditDialog',
  data(): any {
    return {
      name: '',
      formIsValid: true
    };
  },
  props: {
    value: {
      type: Boolean as PropType<boolean>,
      default: (): boolean => false
    },
    processing: {
      type: Boolean as PropType<boolean>,
      default: (): boolean => false
    },
    account: {
      type: Object as PropType<AccountItem>,
      default: (): AccountItem => {
        return {} as AccountItem;
      }
    }
  },
  watch: {
    show(newStatus: boolean): void {
      if (newStatus) {
        this.name = this.account.brandName;
        this.$refs.form?.resetValidation();
      }
    }
  },
  computed: {
    show: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean): void {
        this.$emit('input', value);
      }
    },
    nameRules(): any[] {
      return [(v) => vr.maxLength(v, 32)];
    }
  },
  methods: {
    submitHandler(): void {
      this.$emit('submit', this.account.id, this.name);
    }
  }
};
